//
import { RouteProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { Paragraph } from 'react-native-paper';
import { StackParamList } from '../../../App';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import PlayStoreButton from '../Generic/PlayStoreButton';
import Title from '../Generic/Title';
import ViewStatusPedido from './ViewStatusPedido';

type Props = {
  navigation: StackNavigationProp<StackParamList, 'EsperaPedidoPage'>;
  route: RouteProp<StackParamList, 'EsperaPedidoPage'>;
};

const EsperaPedidoPage: React.FC<Props> = (props) => {
  const { navigation, route } = props;
  const [sessao] = useSessao();
  // const pedidoId = 6;
  const pedidoId = route.params.pedidoId;

  if (!pedidoId) {
    navigation.goBack();
  }

  return (
    <PageContainer header={<Header goBack />}>
      <Title style={{ alignSelf: 'center', marginBottom: 10 }}>Pedido realizado!</Title>
      {Platform.OS === 'web' && (
        <View>
          <Paragraph>
            Como você está acessando pelo site, não receberá notificações sobre seu pedido. Mas você
            ainda pode baixar nosso app e ficar por dentro de tudo que acontecer:
          </Paragraph>
          <PlayStoreButton />
        </View>
      )}
      {Platform.OS !== 'web' && sessao.cliente.pushToken !== '' && (
        <Paragraph>Você receberá notificações sobre tudo que acontecer com o seu pedido.</Paragraph>
      )}

      {Platform.OS !== 'web' && sessao.cliente.pushToken === '' && (
        <Paragraph>
          Parece que não conseguimos permissão para te enviar notificações. Tente refazer o login
          para ficar por dentro de tudo que acontecer com seu pedido.
        </Paragraph>
      )}
      <Paragraph>
        Se preferir, aguarde nessa tela e avisaremos quando seu pedido for lido:
      </Paragraph>

      <ViewStatusPedido id={pedidoId} />
    </PageContainer>
  );
};

const styles = StyleSheet.create({});

export default EsperaPedidoPage;
